// Traducciones de las 80 categorías de COCO-SSD
// Lenguas: territorios filmados (Congo, Ruanda, África central y oriental),
// lengua colonial belga, lenguas africanas de gran uso, y lenguas del sur global.

export const idiomas: { [codigo: string]: string } = {
  ln: 'Lingala',
  sw: 'Kiswahili',
  rw: 'Kinyarwanda',
  kg: 'Kikongo',
  fr: 'Français',
  yo: 'Yorùbá',
  ha: 'Hausa',
  am: 'Amharic — አማርኛ',
  zu: 'isiZulu',
  ar: 'العربية',
  hi: 'हिन्दी',
  qu: 'Quechua',
  gn: 'Guaraní',
  nah: 'Náhuatl',
  zh: '中文',
  es: 'Español',
  pt: 'Português',
};

export type TraduccionesCategoria = { [codigo: string]: string };

export const traducciones: { [categoria: string]: TraduccionesCategoria } = {
  person: {
    ln: 'moto',
    sw: 'mtu',
    rw: 'umuntu',
    kg: 'muntu',
    fr: 'personne',
    yo: 'ènìyàn',
    ha: 'mutum',
    am: 'ሰው',
    zu: 'umuntu',
    ar: 'شخص',
    hi: 'व्यक्ति',
    qu: 'runa',
    gn: 'ava',
    nah: 'tlācatl',
    zh: '人',
    es: 'persona',
    pt: 'pessoa',
  },
  bicycle: {
    ln: 'velo',
    sw: 'baiskeli',
    rw: 'igare',
    kg: 'velo',
    fr: 'vélo',
    yo: 'kẹ̀kẹ̀',
    ha: 'keke',
    am: 'ብስክሌት',
    zu: 'ibhayisikili',
    ar: 'دراجة',
    hi: 'साइकिल',
    qu: 'bisiklita',
    gn: 'bisikleta',
    nah: 'bicicleta',
    zh: '自行车',
    es: 'bicicleta',
    pt: 'bicicleta',
  },
  car: {
    ln: 'mótuka',
    sw: 'gari',
    rw: 'imodoka',
    kg: 'mòtuka',
    fr: 'voiture',
    yo: 'ọkọ̀ ayọkẹlẹ',
    ha: 'mota',
    am: 'መኪና',
    zu: 'imoto',
    ar: 'سيارة',
    hi: 'कार',
    qu: 'awtu',
    gn: 'muvilo',
    nah: 'automóvil',
    zh: '汽车',
    es: 'automóvil',
    pt: 'carro',
  },
  motorcycle: {
    ln: 'moto',
    sw: 'pikipiki',
    rw: 'moto',
    kg: 'moto',
    fr: 'moto',
    yo: 'àyọ̀kẹlẹ',
    ha: 'babur',
    am: 'ሞተር ሳይክል',
    zu: 'imoto enkulu',
    ar: 'دراجة نارية',
    hi: 'मोटरसाइकिल',
    qu: 'motosikilita',
    gn: 'moto',
    nah: 'moto',
    zh: '摩托车',
    es: 'motocicleta',
    pt: 'moto',
  },
  airplane: {
    ln: 'avion',
    sw: 'ndege',
    rw: 'indege',
    kg: 'ndeke',
    fr: 'avion',
    yo: 'ọkọ̀ òfurufú',
    ha: 'jirgin sama',
    am: 'አውሮፕላን',
    zu: 'indiza',
    ar: 'طائرة',
    hi: 'हवाई जहाज',
    qu: 'wayra wasi',
    gn: 'avión',
    nah: 'avión',
    zh: '飞机',
    es: 'avión',
    pt: 'avião',
  },
  bus: {
    ln: 'bisisi',
    sw: 'basi',
    rw: 'bisi',
    kg: 'bisi',
    fr: 'bus',
    yo: 'ọkọ̀ akérébiisi',
    ha: 'bas',
    am: 'አውቶቡስ',
    zu: 'ibhasi',
    ar: 'حافلة',
    hi: 'बस',
    qu: 'busta',
    gn: 'ómnibus',
    nah: 'camión',
    zh: '公共汽车',
    es: 'autobús',
    pt: 'ônibus',
  },
  train: {
    ln: 'tere',
    sw: 'treni',
    rw: 'tireni',
    kg: 'tere',
    fr: 'train',
    yo: 'ọkọ̀ irin',
    ha: 'jirgin ƙasa',
    am: 'ባቡር',
    zu: 'uloliwe',
    ar: 'قطار',
    hi: 'ट्रेन',
    qu: 'trinsita',
    gn: 'tren',
    nah: 'tren',
    zh: '火车',
    es: 'tren',
    pt: 'trem',
  },
  truck: {
    ln: 'kamion',
    sw: 'lori',
    rw: 'imodoka nkuru',
    kg: 'kamion',
    fr: 'camion',
    yo: 'lọ́lọ́',
    ha: 'manyan mota',
    am: 'ትልቅ መኪና',
    zu: 'iloli',
    ar: 'شاحنة',
    hi: 'ट्रक',
    qu: 'kamión',
    gn: 'camión',
    nah: 'camión',
    zh: '卡车',
    es: 'camión',
    pt: 'caminhão',
  },
  boat: {
    ln: 'bwato',
    sw: 'boti',
    rw: 'ubwato',
    kg: 'bwatu',
    fr: 'bateau',
    yo: 'ọkọ̀ ojú omi',
    ha: 'jirgin ruwa',
    am: 'ጀልባ',
    zu: 'isikebhe',
    ar: 'قارب',
    hi: 'नाव',
    qu: 'wampuna',
    gn: 'ygára',
    nah: 'acalli',
    zh: '船',
    es: 'barco',
    pt: 'barco',
  },
  'traffic light': {
    ln: 'feu ya barabara',
    sw: 'taa ya barabara',
    rw: 'itara',
    kg: 'feu',
    fr: 'feu de circulation',
    yo: 'ìmọ̀lẹ̀ ojúpọ̀',
    ha: 'hasken zirga-zirga',
    am: 'የትራፊክ መብራት',
    zu: 'uphawu lomgwaqo',
    ar: 'إشارة المرور',
    hi: 'ट्रैफिक बत्ती',
    qu: 'ñan muyuq',
    gn: 'semáforo',
    nah: 'semáforo',
    zh: '交通灯',
    es: 'semáforo',
    pt: 'semáforo',
  },
  'fire hydrant': {
    ln: 'prise ya mai',
    sw: 'bomba la maji',
    rw: "umuyoboro w'amazi",
    kg: 'prise ya maza',
    fr: 'borne fontaine',
    yo: 'omi ìná',
    ha: 'famfo na wuta',
    am: 'የእሳት ቱቦ',
    zu: 'impompo yamanzi',
    ar: 'صنبور إطفاء',
    hi: 'अग्निशामक नल',
    qu: 'nina yakuy',
    gn: "tata y'u",
    nah: 'atl tletl',
    zh: '消防栓',
    es: 'hidrante',
    pt: 'hidrante',
  },
  'stop sign': {
    ln: 'panneau télémé',
    sw: 'ishara ya simama',
    rw: 'ikimenyetso cyo guhagarara',
    kg: 'signe ya telema',
    fr: 'panneau stop',
    yo: 'ìdámọ̀ dúró',
    ha: 'alama ta tsaya',
    am: 'ቁም ምልክት',
    zu: 'uphawu lokuma',
    ar: 'إشارة قف',
    hi: 'रुको संकेत',
    qu: 'sayay señal',
    gn: 'señal kuarahy',
    nah: 'icxitlan señal',
    zh: '停止标志',
    es: 'señal de pare',
    pt: 'sinal de parada',
  },
  'parking meter': {
    ln: 'compteur ya gari',
    sw: 'mita ya maegesho',
    rw: "metero y'agari",
    kg: 'compteur',
    fr: 'parcmètre',
    yo: 'mítà àgò ọkọ̀',
    ha: 'agogo tanadi',
    am: 'የመኪና ሰዓት',
    zu: 'isilinganisi sokumisa',
    ar: 'عداد وقوف السيارات',
    hi: 'पार्किंग मीटर',
    qu: 'sayay contadur',
    gn: 'parquímetro',
    nah: 'parquímetro',
    zh: '停车收费表',
    es: 'parquímetro',
    pt: 'parquímetro',
  },
  bench: {
    ln: 'banki',
    sw: 'benchi',
    rw: 'intebe nderera',
    kg: 'banki',
    fr: 'banc',
    yo: 'ìjókòó',
    ha: 'benci',
    am: 'የድንጋይ ወንበር',
    zu: 'ibhentshi',
    ar: 'مقعد',
    hi: 'बेंच',
    qu: 'tiyay',
    gn: 'banco',
    nah: 'banco',
    zh: '长椅',
    es: 'banco',
    pt: 'banco',
  },
  bird: {
    ln: 'ndeke',
    sw: 'ndege',
    rw: 'inyoni',
    kg: 'nuni',
    fr: 'oiseau',
    yo: 'ẹyẹ',
    ha: 'tsuntsu',
    am: 'ወፍ',
    zu: 'inyoni',
    ar: 'طائر',
    hi: 'पक्षी',
    qu: 'pisqu',
    gn: 'guyra',
    nah: 'tōtōtl',
    zh: '鸟',
    es: 'pájaro',
    pt: 'pássaro',
  },
  cat: {
    ln: 'nyau',
    sw: 'paka',
    rw: 'injangwe',
    kg: 'nkau',
    fr: 'chat',
    yo: 'ológìnní',
    ha: 'kyanwa',
    am: 'ድመት',
    zu: 'ikati',
    ar: 'قطة',
    hi: 'बिल्ली',
    qu: 'michi',
    gn: 'mbarakaja',
    nah: 'mizton',
    zh: '猫',
    es: 'gato',
    pt: 'gato',
  },
  dog: {
    ln: 'mbwa',
    sw: 'mbwa',
    rw: 'imbwa',
    kg: 'mbwa',
    fr: 'chien',
    yo: 'ajá',
    ha: 'kare',
    am: 'ውሻ',
    zu: 'inja',
    ar: 'كلب',
    hi: 'कुत्ता',
    qu: 'allqu',
    gn: 'jagua',
    nah: 'chichi',
    zh: '狗',
    es: 'perro',
    pt: 'cachorro',
  },
  horse: {
    ln: 'farasa',
    sw: 'farasi',
    rw: 'ifarasi',
    kg: 'kavalu',
    fr: 'cheval',
    yo: 'ẹṣin',
    ha: 'doki',
    am: 'ፈረስ',
    zu: 'ihhashi',
    ar: 'حصان',
    hi: 'घोड़ा',
    qu: 'kawalli',
    gn: 'kavaju',
    nah: 'cahuayo',
    zh: '马',
    es: 'caballo',
    pt: 'cavalo',
  },
  sheep: {
    ln: 'mpate',
    sw: 'kondoo',
    rw: 'intama',
    kg: 'mpate',
    fr: 'mouton',
    yo: 'àgùntàn',
    ha: 'tumaki',
    am: 'በግ',
    zu: 'imvu',
    ar: 'خروف',
    hi: 'भेड़',
    qu: 'uwija',
    gn: 'oveja',
    nah: 'ichcatl',
    zh: '羊',
    es: 'oveja',
    pt: 'ovelha',
  },
  cow: {
    ln: 'ngombe',
    sw: "ng'ombe",
    rw: 'inka',
    kg: 'ngombe',
    fr: 'vache',
    yo: 'màlúù',
    ha: 'saniya',
    am: 'ላም',
    zu: 'inkomo',
    ar: 'بقرة',
    hi: 'गाय',
    qu: 'waka',
    gn: 'vaka',
    nah: 'vacatl',
    zh: '牛',
    es: 'vaca',
    pt: 'vaca',
  },
  elephant: {
    ln: 'nzou',
    sw: 'tembo',
    rw: 'inzovu',
    kg: 'nzau',
    fr: 'éléphant',
    yo: 'erin',
    ha: 'giwā',
    am: 'ዝሆን',
    zu: 'indlovu',
    ar: 'فيل',
    hi: 'हाथी',
    qu: 'paqichu',
    gn: 'elefante',
    nah: 'elefante',
    zh: '大象',
    es: 'elefante',
    pt: 'elefante',
  },
  bear: {
    ln: 'ours',
    sw: 'dubu',
    rw: 'idubu',
    kg: 'ours',
    fr: 'ours',
    yo: 'ẹranko igbó',
    ha: 'beyar',
    am: 'ድብ',
    zu: 'ibhere',
    ar: 'دب',
    hi: 'भालू',
    qu: 'ukuku',
    gn: 'oso',
    nah: 'oso',
    zh: '熊',
    es: 'oso',
    pt: 'urso',
  },
  zebra: {
    ln: 'zebra',
    sw: 'punda milia',
    rw: 'inzebe',
    kg: 'zebra',
    fr: 'zèbre',
    yo: 'ẹṣin àlábàárà',
    ha: 'kuda ruwan daji',
    am: 'ዝብራ',
    zu: 'idube',
    ar: 'حمار وحشي',
    hi: 'ज़ेबरा',
    qu: 'cebra',
    gn: 'cebra',
    nah: 'cebra',
    zh: '斑马',
    es: 'cebra',
    pt: 'zebra',
  },
  giraffe: {
    ln: 'jirafé',
    sw: 'twiga',
    rw: 'indiri',
    kg: 'jirafé',
    fr: 'girafe',
    yo: 'ẹranko giga',
    ha: 'raƙumi',
    am: 'ቀጭኔ',
    zu: 'indlulamithi',
    ar: 'زرافة',
    hi: 'जिराफ',
    qu: 'jirafa',
    gn: 'jirafa',
    nah: 'jirafa',
    zh: '长颈鹿',
    es: 'jirafa',
    pt: 'girafa',
  },
  backpack: {
    ln: 'sac ya mokolo',
    sw: 'mkoba',
    rw: "umufuko w'umugongo",
    kg: 'sac',
    fr: 'sac à dos',
    yo: 'àpo ẹ̀yìn',
    ha: 'jaka',
    am: 'ቦርሳ',
    zu: 'umgwembe',
    ar: 'حقيبة ظهر',
    hi: 'बैग',
    qu: 'wistalla',
    gn: 'mochila',
    nah: 'mochila',
    zh: '背包',
    es: 'mochila',
    pt: 'mochila',
  },
  umbrella: {
    ln: 'ndela',
    sw: 'mwavuli',
    rw: 'induduro',
    kg: 'ndela',
    fr: 'parapluie',
    yo: 'àgbádò ojú ọjọ́',
    ha: 'laima',
    am: 'ጃንጥላ',
    zu: 'isembrela',
    ar: 'مظلة',
    hi: 'छाता',
    qu: "p'acha",
    gn: 'sombrilla',
    nah: 'quiyahuitl',
    zh: '雨伞',
    es: 'paraguas',
    pt: 'guarda-chuva',
  },
  handbag: {
    ln: 'sac ya loboko',
    sw: 'mfuko',
    rw: 'isaho',
    kg: 'sac',
    fr: 'sac à main',
    yo: 'àpo',
    ha: 'jaka',
    am: 'ቦርሳ',
    zu: 'isikhwama',
    ar: 'حقيبة يد',
    hi: 'पर्स',
    qu: 'wayaka',
    gn: 'bolso',
    nah: 'bolso',
    zh: '手提包',
    es: 'bolso',
    pt: 'bolsa',
  },
  tie: {
    ln: 'cravate',
    sw: 'tai',
    rw: 'ikaravate',
    kg: 'cravate',
    fr: 'cravate',
    yo: 'tai',
    ha: 'tai',
    am: 'ክራቫት',
    zu: 'ithayi',
    ar: 'ربطة عنق',
    hi: 'टाई',
    qu: 'corbata',
    gn: 'corbata',
    nah: 'corbata',
    zh: '领带',
    es: 'corbata',
    pt: 'gravata',
  },
  suitcase: {
    ln: 'valise',
    sw: 'mzigo',
    rw: "umufuko w'urugendo",
    kg: 'valisi',
    fr: 'valise',
    yo: 'ẹrù',
    ha: 'akwatin tafiya',
    am: 'ሻንጣ',
    zu: 'isikhwama sohambo',
    ar: 'حقيبة سفر',
    hi: 'सूटकेस',
    qu: 'maleta',
    gn: 'maleta',
    nah: 'maleta',
    zh: '行李箱',
    es: 'maleta',
    pt: 'mala',
  },
  frisbee: {
    ln: 'frisbee',
    sw: 'frisbee',
    rw: 'frisbee',
    kg: 'frisbee',
    fr: 'frisbee',
    yo: 'frisbee',
    ha: 'frisbee',
    am: 'ፍሪስቢ',
    zu: 'ifrisbee',
    ar: 'فريسبي',
    hi: 'फ्रिसबी',
    qu: 'frisbee',
    gn: 'frisbee',
    nah: 'frisbee',
    zh: '飞盘',
    es: 'frisbee',
    pt: 'frisbee',
  },
  skis: {
    ln: 'skis',
    sw: 'ski',
    rw: 'skis',
    kg: 'skis',
    fr: 'skis',
    yo: 'skis',
    ha: 'ski',
    am: 'ስኪ',
    zu: 'izingamaskhi',
    ar: 'تزلج',
    hi: 'स्की',
    qu: 'skis',
    gn: 'skis',
    nah: 'skis',
    zh: '滑雪板',
    es: 'esquís',
    pt: 'esquis',
  },
  snowboard: {
    ln: 'snowboard',
    sw: 'ubao wa theluji',
    rw: 'snowboard',
    kg: 'snowboard',
    fr: 'snowboard',
    yo: 'snowboard',
    ha: 'snowboard',
    am: 'ስኖቦርድ',
    zu: 'isnowboard',
    ar: 'لوح التزلج على الجليد',
    hi: 'स्नोबोर्ड',
    qu: 'snowboard',
    gn: 'snowboard',
    nah: 'snowboard',
    zh: '单板滑雪',
    es: 'snowboard',
    pt: 'snowboard',
  },
  'sports ball': {
    ln: 'bale',
    sw: 'mpira',
    rw: 'umupira',
    kg: 'bale',
    fr: 'ballon',
    yo: 'bọọlù',
    ha: 'ƙwallo',
    am: 'ኳስ',
    zu: 'ibhola',
    ar: 'كرة',
    hi: 'गेंद',
    qu: 'pelota',
    gn: 'pelota',
    nah: 'ollamaitl',
    zh: '球',
    es: 'pelota',
    pt: 'bola',
  },
  kite: {
    ln: 'cerf-volant',
    sw: 'ndege ya karatasi',
    rw: 'igikabiri',
    kg: 'cerf-volant',
    fr: 'cerf-volant',
    yo: 'àpáta afẹ́fẹ́',
    ha: 'takarda ta iska',
    am: 'ወረቀት ወፍ',
    zu: 'inkayishi',
    ar: 'طائرة ورقية',
    hi: 'पतंग',
    qu: 'wayra wawa',
    gn: 'cometa',
    nah: 'cerf-volant',
    zh: '风筝',
    es: 'cometa',
    pt: 'pipa',
  },
  'baseball bat': {
    ln: 'bate ya baseball',
    sw: 'piga ya besiboli',
    rw: 'inkoni ya beisiboli',
    kg: 'bate',
    fr: 'batte de baseball',
    yo: 'ọpá baseball',
    ha: 'sanda na kwallon baseball',
    am: 'የቤዝቦል ዘንግ',
    zu: 'induku ye-baseball',
    ar: 'مضرب البيسبول',
    hi: 'बैट',
    qu: 'bate',
    gn: 'bate',
    nah: 'bate',
    zh: '棒球棒',
    es: 'bate de béisbol',
    pt: 'taco de beisebol',
  },
  'baseball glove': {
    ln: 'gant ya baseball',
    sw: 'glavu ya besiboli',
    rw: 'intoki ya beisiboli',
    kg: 'gant',
    fr: 'gant de baseball',
    yo: 'ìbọ̀wọ́ baseball',
    ha: 'hannu na kwallon baseball',
    am: 'የቤዝቦል ጓንት',
    zu: 'igilavu le-baseball',
    ar: 'قفاز البيسبول',
    hi: 'दस्ताना',
    qu: 'guante',
    gn: 'guante',
    nah: 'guante',
    zh: '棒球手套',
    es: 'guante de béisbol',
    pt: 'luva de beisebol',
  },
  skateboard: {
    ln: 'skateboard',
    sw: 'bodi ya magurudumu',
    rw: 'skateboard',
    kg: 'skateboard',
    fr: 'skateboard',
    yo: 'skateboard',
    ha: 'skateboard',
    am: 'ስኬትቦርድ',
    zu: 'isikhethibhodi',
    ar: 'لوح التزلج',
    hi: 'स्केटबोर्ड',
    qu: 'skateboard',
    gn: 'skateboard',
    nah: 'skateboard',
    zh: '滑板',
    es: 'patineta',
    pt: 'skate',
  },
  surfboard: {
    ln: 'planche ya mbalé',
    sw: 'ubao wa mawimbi',
    rw: "ubao w'amazi",
    kg: 'planche',
    fr: 'planche de surf',
    yo: 'pákò omi',
    ha: 'allunan ruwa',
    am: 'የሞገድ ሰሌዳ',
    zu: 'ibhodi lokusarfa',
    ar: 'لوح ركوب الأمواج',
    hi: 'सर्फ़बोर्ड',
    qu: 'surfboard',
    gn: 'surfboard',
    nah: 'surfboard',
    zh: '冲浪板',
    es: 'tabla de surf',
    pt: 'prancha de surfe',
  },
  'tennis racket': {
    ln: 'raquette',
    sw: 'raketi',
    rw: 'iraketi',
    kg: 'raquette',
    fr: 'raquette de tennis',
    yo: 'rákẹ́ẹ̀tì',
    ha: 'raketi',
    am: 'ራኬት',
    zu: 'irakhethi',
    ar: 'مضرب التنس',
    hi: 'रैकेट',
    qu: 'raqueta',
    gn: 'raqueta',
    nah: 'raqueta',
    zh: '网球拍',
    es: 'raqueta',
    pt: 'raquete',
  },
  bottle: {
    ln: 'bouteille',
    sw: 'chupa',
    rw: 'icupa',
    kg: 'butelu',
    fr: 'bouteille',
    yo: 'ìgò',
    ha: 'kwalba',
    am: 'ጠርሙስ',
    zu: 'ibhodlela',
    ar: 'زجاجة',
    hi: 'बोतल',
    qu: 'chupa',
    gn: 'botella',
    nah: 'comitl',
    zh: '瓶子',
    es: 'botella',
    pt: 'garrafa',
  },
  'wine glass': {
    ln: 'verre ya vin',
    sw: 'glasi ya divai',
    rw: "inzogera y'inzoga",
    kg: 'verre',
    fr: 'verre à vin',
    yo: 'ìkòkò ọtí',
    ha: 'gilashi na giya',
    am: 'የወይን ብርጭቆ',
    zu: 'ingilazi yaywayini',
    ar: 'كأس نبيذ',
    hi: 'वाइन गिलास',
    qu: 'vaso',
    gn: 'copa',
    nah: 'copa',
    zh: '酒杯',
    es: 'copa de vino',
    pt: 'taça de vinho',
  },
  cup: {
    ln: 'tasse',
    sw: 'kikombe',
    rw: 'igikombe',
    kg: 'tasi',
    fr: 'tasse',
    yo: 'ife',
    ha: 'kwaf',
    am: 'ኩባያ',
    zu: 'inkomishi',
    ar: 'كوب',
    hi: 'कप',
    qu: 'puñu',
    gn: 'vaso',
    nah: 'caxitl',
    zh: '杯子',
    es: 'taza',
    pt: 'xícara',
  },
  fork: {
    ln: 'fourchette',
    sw: 'uma',
    rw: 'imbembe',
    kg: 'fourchette',
    fr: 'fourchette',
    yo: 'ìdá oúnjẹ',
    ha: 'cokali',
    am: 'ሹካ',
    zu: 'ifolokhwe',
    ar: 'شوكة',
    hi: 'कांटा',
    qu: 'tenedor',
    gn: 'tenedor',
    nah: 'tenedor',
    zh: '叉子',
    es: 'tenedor',
    pt: 'garfo',
  },
  knife: {
    ln: 'mopanga',
    sw: 'kisu',
    rw: 'imbugita',
    kg: 'mopangu',
    fr: 'couteau',
    yo: 'ọbẹ',
    ha: 'wuka',
    am: 'ቢላ',
    zu: 'imela',
    ar: 'سكين',
    hi: 'चाकू',
    qu: 'kuchillo',
    gn: 'kuchillo',
    nah: 'técpatl',
    zh: '刀',
    es: 'cuchillo',
    pt: 'faca',
  },
  spoon: {
    ln: 'cuillère',
    sw: 'kijiko',
    rw: 'ikijiko',
    kg: 'cuillère',
    fr: 'cuillère',
    yo: 'sibi',
    ha: 'cokali',
    am: 'ማንኪያ',
    zu: 'isipunu',
    ar: 'ملعقة',
    hi: 'चम्मच',
    qu: "lluch'u",
    gn: 'cuchara',
    nah: 'cuchara',
    zh: '勺子',
    es: 'cuchara',
    pt: 'colher',
  },
  bowl: {
    ln: 'bol',
    sw: 'bakuli',
    rw: 'icano',
    kg: 'bol',
    fr: 'bol',
    yo: 'ìkòkò',
    ha: 'kwano',
    am: 'ጥልቅ ሰሃን',
    zu: 'isitsha',
    ar: 'وعاء',
    hi: 'कटोरी',
    qu: 'manka',
    gn: 'bol',
    nah: 'caxitl',
    zh: '碗',
    es: 'bol',
    pt: 'tigela',
  },
  banana: {
    ln: 'liboke',
    sw: 'ndizi',
    rw: 'igitoki',
    kg: 'mbizi',
    fr: 'banane',
    yo: 'ọgẹ̀dẹ̀',
    ha: 'ayaba',
    am: 'ሙዝ',
    zu: 'ubhanana',
    ar: 'موز',
    hi: 'केला',
    qu: 'gatin',
    gn: 'tatakua',
    nah: 'tzapotl',
    zh: '香蕉',
    es: 'banano',
    pt: 'banana',
  },
  apple: {
    ln: 'pome',
    sw: 'tofaa',
    rw: 'iaporo',
    kg: 'pome',
    fr: 'pomme',
    yo: 'àpùl',
    ha: 'apple',
    am: 'ፖም',
    zu: 'i-aphula',
    ar: 'تفاحة',
    hi: 'सेब',
    qu: 'mansana',
    gn: 'manzana',
    nah: 'xocotl',
    zh: '苹果',
    es: 'manzana',
    pt: 'maçã',
  },
  sandwich: {
    ln: 'sandwiche',
    sw: 'sandwich',
    rw: 'isandwichi',
    kg: 'sandwiche',
    fr: 'sandwich',
    yo: 'sandwich',
    ha: 'sandwich',
    am: 'ሳንድዊች',
    zu: 'isandwitshi',
    ar: 'ساندويتش',
    hi: 'सैंडविच',
    qu: 'sandwich',
    gn: 'sandwich',
    nah: 'sandwich',
    zh: '三明治',
    es: 'sándwich',
    pt: 'sanduíche',
  },
  orange: {
    ln: 'lilala',
    sw: 'chungwa',
    rw: 'icungwa',
    kg: 'lalange',
    fr: 'orange',
    yo: 'ọsàn',
    ha: 'lemu',
    am: 'ብርቱካን',
    zu: 'iolintshi',
    ar: 'برتقالة',
    hi: 'संतरा',
    qu: 'naranja',
    gn: 'naranja',
    nah: 'naranja',
    zh: '橙子',
    es: 'naranja',
    pt: 'laranja',
  },
  broccoli: {
    ln: 'brocoli',
    sw: 'brokoli',
    rw: 'brokoli',
    kg: 'brocoli',
    fr: 'brocoli',
    yo: 'brokoli',
    ha: 'brokoli',
    am: 'ብሮኮሊ',
    zu: 'ibhrokholi',
    ar: 'بروكلي',
    hi: 'ब्रोकोली',
    qu: 'brokoli',
    gn: 'brokoli',
    nah: 'brócoli',
    zh: '西兰花',
    es: 'brócoli',
    pt: 'brócolis',
  },
  carrot: {
    ln: 'karoti',
    sw: 'karoti',
    rw: 'karote',
    kg: 'karoti',
    fr: 'carotte',
    yo: 'kárọ̀ọ̀tì',
    ha: 'karas',
    am: 'ካሮት',
    zu: 'ikharikhisi',
    ar: 'جزرة',
    hi: 'गाजर',
    qu: 'zanahoria',
    gn: 'zanahoria',
    nah: 'iztatl',
    zh: '胡萝卜',
    es: 'zanahoria',
    pt: 'cenoura',
  },
  'hot dog': {
    ln: 'hot dog',
    sw: 'hot dog',
    rw: 'hot dog',
    kg: 'hot dog',
    fr: 'hot dog',
    yo: 'hot dog',
    ha: 'hot dog',
    am: 'ሆት ዶግ',
    zu: 'ihotdogi',
    ar: 'هوت دوغ',
    hi: 'हॉट डॉग',
    qu: 'hot dog',
    gn: 'hot dog',
    nah: 'hot dog',
    zh: '热狗',
    es: 'perro caliente',
    pt: 'cachorro-quente',
  },
  pizza: {
    ln: 'pizza',
    sw: 'piza',
    rw: 'pizza',
    kg: 'pizza',
    fr: 'pizza',
    yo: 'pizza',
    ha: 'pizza',
    am: 'ፒዛ',
    zu: 'ipizza',
    ar: 'بيتزا',
    hi: 'पिज़्ज़ा',
    qu: 'pizza',
    gn: 'pizza',
    nah: 'pizza',
    zh: '披萨',
    es: 'pizza',
    pt: 'pizza',
  },
  donut: {
    ln: 'beignet',
    sw: 'donati',
    rw: 'idonete',
    kg: 'beignet',
    fr: 'beignet',
    yo: 'àkàrà',
    ha: 'beignet',
    am: 'ዶናት',
    zu: 'idonatsi',
    ar: 'دونات',
    hi: 'डोनट',
    qu: 'rosquilla',
    gn: 'rosquilla',
    nah: 'donut',
    zh: '甜甜圈',
    es: 'dona',
    pt: 'rosquinha',
  },
  cake: {
    ln: 'gâteau',
    sw: 'keki',
    rw: 'urukate',
    kg: 'gâteau',
    fr: 'gâteau',
    yo: 'kéèkì',
    ha: 'kek',
    am: 'ኬክ',
    zu: 'ikhekhe',
    ar: 'كعكة',
    hi: 'केक',
    qu: 'torta',
    gn: 'torta',
    nah: 'tlaxcalli',
    zh: '蛋糕',
    es: 'pastel',
    pt: 'bolo',
  },
  chair: {
    ln: 'chaise',
    sw: 'kiti',
    rw: 'intebe',
    kg: 'kiti',
    fr: 'chaise',
    yo: 'ìtẹ́lẹ̀',
    ha: 'kujera',
    am: 'ወንበር',
    zu: 'isihlalo',
    ar: 'كرسي',
    hi: 'कुर्सी',
    qu: 'tiyarina',
    gn: 'silla',
    nah: 'icpalli',
    zh: '椅子',
    es: 'silla',
    pt: 'cadeira',
  },
  couch: {
    ln: 'canapé',
    sw: 'sofa',
    rw: 'sofa',
    kg: 'canapé',
    fr: 'canapé',
    yo: 'àga',
    ha: 'sofa',
    am: 'ሶፋ',
    zu: 'isofa',
    ar: 'أريكة',
    hi: 'सोफा',
    qu: 'sofa',
    gn: 'sofá',
    nah: 'sofá',
    zh: '沙发',
    es: 'sofá',
    pt: 'sofá',
  },
  'potted plant': {
    ln: 'nzete ya bonga',
    sw: 'mmea wa chungu',
    rw: 'igiti cyo mu gasibo',
    kg: 'nti ya bonga',
    fr: 'plante en pot',
    yo: 'ewé àgbàdo',
    ha: 'shuka na tukunya',
    am: 'የድስት ተክል',
    zu: 'isitshalo esisentweni',
    ar: 'نبات في وعاء',
    hi: 'गमले का पौधा',
    qu: 'mallki',
    gn: "ka'aguy",
    nah: 'xochitl',
    zh: '盆栽植物',
    es: 'planta en maceta',
    pt: 'planta em vaso',
  },
  bed: {
    ln: 'kitanda',
    sw: 'kitanda',
    rw: 'igitanda',
    kg: 'kibanda',
    fr: 'lit',
    yo: 'àkètà',
    ha: 'gado',
    am: 'አልጋ',
    zu: 'umbhede',
    ar: 'سرير',
    hi: 'बिस्तर',
    qu: 'kama',
    gn: 'kama',
    nah: 'petlatl',
    zh: '床',
    es: 'cama',
    pt: 'cama',
  },
  'dining table': {
    ln: 'table ya kolia',
    sw: 'meza ya chakula',
    rw: 'imeza yo kurya',
    kg: 'table',
    fr: 'table à manger',
    yo: 'tábìlì oúnjẹ',
    ha: 'teburin ci abinci',
    am: 'የምግብ ጠረጴዛ',
    zu: 'itafula lokudlela',
    ar: 'طاولة طعام',
    hi: 'खाने की मेज़',
    qu: 'manka churana',
    gn: 'mesa',
    nah: 'quauitl',
    zh: '餐桌',
    es: 'mesa de comedor',
    pt: 'mesa de jantar',
  },
  toilet: {
    ln: 'toilette',
    sw: 'choo',
    rw: 'umusarani',
    kg: 'toilette',
    fr: 'toilettes',
    yo: 'ilé ìgbọ̀nsẹ̀',
    ha: 'bandaki',
    am: 'መጸዳጃ',
    zu: 'ithoyilethi',
    ar: 'مرحاض',
    hi: 'शौचालय',
    qu: 'uñay wasi',
    gn: 'toilet',
    nah: 'cuitlatl',
    zh: '厕所',
    es: 'inodoro',
    pt: 'vaso sanitário',
  },
  tv: {
    ln: 'tele',
    sw: 'runinga',
    rw: 'televiziyo',
    kg: 'tele',
    fr: 'télévision',
    yo: 'tẹlifísọ̀n',
    ha: 'talabijin',
    am: 'ቴሌቪዥን',
    zu: 'umabonakude',
    ar: 'تلفاز',
    hi: 'टेलीविजन',
    qu: 'televizion',
    gn: 'televisión',
    nah: 'televisión',
    zh: '电视',
    es: 'televisión',
    pt: 'televisão',
  },
  laptop: {
    ln: 'ordinateur',
    sw: 'kompyuta',
    rw: 'mudasobwa',
    kg: 'ordinateur',
    fr: 'ordinateur portable',
    yo: 'kọ̀mpútà',
    ha: 'kwamfuta',
    am: 'ላፕቶፕ',
    zu: 'ikhompyutha',
    ar: 'حاسوب محمول',
    hi: 'लैपटॉप',
    qu: 'computadur',
    gn: 'computadora',
    nah: 'computadora',
    zh: '笔记本电脑',
    es: 'computador',
    pt: 'notebook',
  },
  mouse: {
    ln: 'souris',
    sw: 'kipanya',
    rw: 'mausu',
    kg: 'souris',
    fr: 'souris',
    yo: 'eku',
    ha: 'ɓera',
    am: 'አይጥ',
    zu: 'imbiba',
    ar: 'فأرة الحاسوب',
    hi: 'माउस',
    qu: 'maus',
    gn: 'mouse',
    nah: 'mouse',
    zh: '鼠标',
    es: 'ratón',
    pt: 'mouse',
  },
  remote: {
    ln: 'télécommande',
    sw: 'remouto',
    rw: 'telecomande',
    kg: 'télécommande',
    fr: 'télécommande',
    yo: 'ìgbéjáde',
    ha: 'mai sarrafa daga nesa',
    am: 'ሪሞት',
    zu: 'irimote',
    ar: 'جهاز تحكم',
    hi: 'रिमोट',
    qu: 'rimouto',
    gn: 'control remoto',
    nah: 'control',
    zh: '遥控器',
    es: 'control remoto',
    pt: 'controle remoto',
  },
  keyboard: {
    ln: 'clavier',
    sw: 'kibodi',
    rw: 'keyboard',
    kg: 'clavier',
    fr: 'clavier',
    yo: 'pẹpẹ ìtẹ̀wé',
    ha: 'kibod',
    am: 'ኪቦርድ',
    zu: 'ikhhibhodi',
    ar: 'لوحة مفاتيح',
    hi: 'कीबोर्ड',
    qu: 'teclado',
    gn: 'teclado',
    nah: 'teclado',
    zh: '键盘',
    es: 'teclado',
    pt: 'teclado',
  },
  'cell phone': {
    ln: 'telefone',
    sw: 'simu',
    rw: 'telefone',
    kg: 'telefone',
    fr: 'téléphone portable',
    yo: 'fóònù',
    ha: 'wayar salula',
    am: 'ሞባይል',
    zu: 'iselula',
    ar: 'هاتف محمول',
    hi: 'मोबाइल',
    qu: 'celular',
    gn: 'celular',
    nah: 'celular',
    zh: '手机',
    es: 'celular',
    pt: 'celular',
  },
  microwave: {
    ln: 'micro-ondes',
    sw: 'microwave',
    rw: 'microwave',
    kg: 'micro-ondes',
    fr: 'micro-ondes',
    yo: 'àgo ooru',
    ha: 'murƙusar abinci',
    am: 'ማይክሮዌቭ',
    zu: 'imayikhrowevu',
    ar: 'ميكروويف',
    hi: 'माइक्रोवेव',
    qu: 'microwave',
    gn: 'microondas',
    nah: 'microondas',
    zh: '微波炉',
    es: 'microondas',
    pt: 'micro-ondas',
  },
  oven: {
    ln: 'four',
    sw: 'tanuru',
    rw: 'iforno',
    kg: 'four',
    fr: 'four',
    yo: 'àgo ìdin',
    ha: 'murƙusar burodi',
    am: 'ምድጃ',
    zu: 'ioveni',
    ar: 'فرن',
    hi: 'भट्टी',
    qu: 'qoncha',
    gn: 'horno',
    nah: 'tletl',
    zh: '烤箱',
    es: 'horno',
    pt: 'forno',
  },
  toaster: {
    ln: 'grille-pain',
    sw: 'grili ya mkate',
    rw: 'toaster',
    kg: 'grille-pain',
    fr: 'grille-pain',
    yo: 'àgo búrẹ́dì',
    ha: 'mai ƙona burodi',
    am: 'ቶስተር',
    zu: 'itousta',
    ar: 'محمصة خبز',
    hi: 'टोस्टर',
    qu: 'toaster',
    gn: 'tostadora',
    nah: 'tostadora',
    zh: '烤面包机',
    es: 'tostadora',
    pt: 'torradeira',
  },
  sink: {
    ln: 'évier',
    sw: 'sinki',
    rw: 'isink',
    kg: 'évier',
    fr: 'évier',
    yo: 'ibùsọ̀ omi',
    ha: 'famfon wanka',
    am: 'ሲንክ',
    zu: 'isitsha samanzi',
    ar: 'حوض المطبخ',
    hi: 'सिंक',
    qu: 'sink',
    gn: 'pileta',
    nah: 'atlacomitl',
    zh: '水槽',
    es: 'fregadero',
    pt: 'pia',
  },
  refrigerator: {
    ln: 'frigo',
    sw: 'jokofu',
    rw: 'frigo',
    kg: 'frigo',
    fr: 'réfrigérateur',
    yo: 'ìtọ́jú oúnjẹ',
    ha: 'firji',
    am: 'ፍሪጅ',
    zu: 'ifiriji',
    ar: 'ثلاجة',
    hi: 'फ्रिज',
    qu: 'refrigerador',
    gn: 'heladera',
    nah: 'refrigerador',
    zh: '冰箱',
    es: 'nevera',
    pt: 'geladeira',
  },
  book: {
    ln: 'buku',
    sw: 'kitabu',
    rw: 'igitabo',
    kg: 'ntoma',
    fr: 'livre',
    yo: 'ìwé',
    ha: 'littafi',
    am: 'መጽሐፍ',
    zu: 'incwadi',
    ar: 'كتاب',
    hi: 'किताब',
    qu: 'liwru',
    gn: 'kuatia',
    nah: 'āmoxtli',
    zh: '书',
    es: 'libro',
    pt: 'livro',
  },
  clock: {
    ln: 'montre',
    sw: 'saa',
    rw: 'isaha',
    kg: 'montre',
    fr: 'horloge',
    yo: 'àgogo',
    ha: 'agogo',
    am: 'ሰዓት',
    zu: 'iwashi',
    ar: 'ساعة',
    hi: 'घड़ी',
    qu: 'reloj',
    gn: 'reloj',
    nah: 'cahuitl',
    zh: '时钟',
    es: 'reloj',
    pt: 'relógio',
  },
  vase: {
    ln: 'vase',
    sw: 'chombo cha maua',
    rw: "imbuto y'amashuri",
    kg: 'vase',
    fr: 'vase',
    yo: 'àwo àpò ododo',
    ha: 'tukunya',
    am: 'አበባ ማስቀመጫ',
    zu: 'ivasi',
    ar: 'مزهرية',
    hi: 'फूलदान',
    qu: 'vase',
    gn: 'vaso',
    nah: 'xochicomitl',
    zh: '花瓶',
    es: 'jarrón',
    pt: 'vaso',
  },
  scissors: {
    ln: 'ciseaux',
    sw: 'mkasi',
    rw: 'imikasi',
    kg: 'ciseaux',
    fr: 'ciseaux',
    yo: 'àáké',
    ha: 'almakashi',
    am: 'መቀስ',
    zu: 'isikelo',
    ar: 'مقص',
    hi: 'कैंची',
    qu: 'kuchuna',
    gn: 'tijera',
    nah: 'tlaxintepoztli',
    zh: '剪刀',
    es: 'tijeras',
    pt: 'tesoura',
  },
  'teddy bear': {
    ln: 'nounours',
    sw: 'dubu ya watoto',
    rw: "inzuki y'urukundo",
    kg: 'nounours',
    fr: 'ours en peluche',
    yo: 'ẹranko àṣà',
    ha: 'dubu na yara',
    am: 'ፍቅር ድብ',
    zu: 'ibhere lezitsha',
    ar: 'دمية دب',
    hi: 'खिलौना भालू',
    qu: 'pelush oso',
    gn: 'osito de peluche',
    nah: 'oso teddy',
    zh: '玩具熊',
    es: 'oso de peluche',
    pt: 'ursinho de pelúcia',
  },
  'hair drier': {
    ln: 'sèche-cheveux',
    sw: 'dirayi ya nywele',
    rw: 'seche-cheveux',
    kg: 'sèche-cheveux',
    fr: 'sèche-cheveux',
    yo: 'àgò irun',
    ha: 'mai bushewar gashi',
    am: 'ፀጉር ማድረቂያ',
    zu: 'isomiso senwele',
    ar: 'مجفف الشعر',
    hi: 'हेयर ड्रायर',
    qu: 'secadora',
    gn: 'secadora',
    nah: 'secadora',
    zh: '吹风机',
    es: 'secador de cabello',
    pt: 'secador de cabelo',
  },
  toothbrush: {
    ln: 'brosse ya meno',
    sw: 'mswaki',
    rw: "inshyangatsi y'amenyo",
    kg: 'brosse ya minu',
    fr: 'brosse à dents',
    yo: 'fìràṣì eyin',
    ha: 'buroshi na haƙori',
    am: 'የጥርስ ብሩሽ',
    zu: 'isikhuphu amazinyo',
    ar: 'فرشاة أسنان',
    hi: 'टूथब्रश',
    qu: 'churanas',
    gn: 'cepillo',
    nah: 'tlantepoztli',
    zh: '牙刷',
    es: 'cepillo de dientes',
    pt: 'escova de dentes',
  },
};
